import { L10n } from '../L10n/L10n';
import { Module } from '../Module';

export interface ILocalizedCountFilter {
  (count: number): string;
}

Module.instance().filter('localizedCount', (): ILocalizedCountFilter => {
  return L10n.localizedCount;
});
